/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Work_Order_Publish_Overlap_PreviousInputs */

const en_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} overlaps with the previous event.
 Would you like to ABORT your export?`)
};

const fr_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L’événement ${i?.index} chevauche l’événement précédent.
 Voulez-vous ABANDONNER l’exportation ?`)
};

const de_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index} überschneidet sich mit dem vorherigen Ereignis.
Möchten Sie Ihren Export abbrechen?`)
};

const it_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} si sovrappone all'evento precedente.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} перекрывается с предыдущим событием.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} se superpone con el evento anterior.
¿Desea cancelar la exportación?`)
};

const zh_cn2_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 与上一个事件重叠。

是否要中止导出？`)
};

const ja_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} は前のイベントと重複しています。
エクスポートを中止しますか?`)
};

const hi_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} पिछले इवेंट के साथ ओवरलैप हो रहा है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_work_order_publish_overlap_previous = /** @type {(inputs: Work_Order_Publish_Overlap_PreviousInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} se sobrepõe ao evento anterior.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} overlaps with the previous event. Would you like to ABORT your export?" |
*
* @param {Work_Order_Publish_Overlap_PreviousInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_overlap_previous = /** @type {((inputs: Work_Order_Publish_Overlap_PreviousInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Overlap_PreviousInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_overlap_previous(inputs)
	if (locale === "de") return de_work_order_publish_overlap_previous(inputs)
	if (locale === "it") return it_work_order_publish_overlap_previous(inputs)
	if (locale === "ru") return ru_work_order_publish_overlap_previous(inputs)
	if (locale === "es") return es_work_order_publish_overlap_previous(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_overlap_previous(inputs)
	if (locale === "ja") return ja_work_order_publish_overlap_previous(inputs)
	if (locale === "hi") return hi_work_order_publish_overlap_previous(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_overlap_previous(inputs)
	return en_work_order_publish_overlap_previous(inputs)
});